export * from "./get-all-templet";
